import React from "react";
import {
  Box,
  Button,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useFormContext, useWatch } from "react-hook-form";
import NexIcon from "../../assets/img/next.svg";
import { black, white } from "../../constants/colors";
import { getCheckPaymentPs } from '../../utils/productUtils';

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  styles: {
    color: ({ location }) => (location === "form" ? black : white),
    [down("sm")]: {
      "& h4": {
        fontSize: "16px",
      },
    },
  },
}));

const NextButton = ({
  handleNext,
  selectedFlight,
  disabled,
  location,
  hidePrice,
  tipsValue,
}) => {
  const classes = useStyles({ location });
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const { getValues } = useFormContext();
  const acceptTipsValue =
    useWatch({ name: "acceptTips" }) || getValues("acceptTips");
  const travelCareValue =
    useWatch({ name: "travelCare" }) || getValues("travelCare");
  const manualSplitValue =
    useWatch({ name: "manualSplit" }) || getValues("manualSplit");


  const inhouseCharge = () => {
    const ckPs = getCheckPaymentPs( selectedFlight ) + 1
    const {tbc, airline} = selectedFlight.taxes

    return manualSplitValue ? tbc + airline * ckPs : tbc
  }

  const airlineCharge = () => {
    const {tbc, airline} = selectedFlight.taxes

    return manualSplitValue ? 0 : airline
  }

  const priceOfferCalc = () => {
    return inhouseCharge() + airlineCharge()
  }

  const calcPrice = () => {
    let price = priceOfferCalc()

    if (travelCareValue === "applyProtection") {
      price = price + selectedFlight?.travelCarePrice;
    }
    if (acceptTipsValue) {
      price = price + Number(tipsValue);
    }
    return price.toFixed(2);
  };

  const totalText = selectedFlight.passengers?.all > 1 ? 'Total ' : ''

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      className={classes.styles}
    >
      {!hidePrice && (
        <Box mr={1}>
          <Typography variant="h4">{`${totalText}$${calcPrice()}`}</Typography>
        </Box>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={handleNext}
        disabled={disabled}
      >
        <Typography>{sm ? "Next" : "Confirm and pay"}</Typography>
        <Box ml={0.5} display="flex">
          <img src={NexIcon} alt="next-icon" />
        </Box>
      </Button>
    </Box>
  );
};

export default NextButton;
